import React, {useState} from "react";
import {LoaderFunctionArgs, useLoaderData, useParams} from "react-router-dom";
import axios from "axios";
import {Snackbar} from "@mui/material";
import OutstandingDataGrid from "../components/OutstandingDataGrid";

export interface Outstanding {
    id: number
    playerName : string
    characterName : string
    crafting: boolean | null
}

export const outstandingLoader = async ({params}: LoaderFunctionArgs): Promise<Outstanding[]> => {
    if (!params.eventId) return []
    const apiEndpoint = `/api/events/${params.eventId}/outstanding/`
    return await axios.get(apiEndpoint).then(({data}) => {
        return data;
    })
}

export default function OutstandingItems() {
    const {eventId} = useParams<{eventId: string}>()
    const [outstandingActions, setoutstandingActions] = useState(useLoaderData() as Outstanding[]);
    const [open, setOpen] = React.useState(false);

    const saveOutstanding = async (p: Outstanding) => {
        const apiEndpoint = `/api/events/${eventId}/outstanding/` + p.id
        await axios.post(apiEndpoint, p).then(({data}) => {
            setOpen(true)
        })
    }

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    return (
        <React.Fragment>
            <OutstandingDataGrid outstandingActions={outstandingActions} onEdit={saveOutstanding}/>
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message="Payment Updated"
            />
        </React.Fragment>
    )
}